// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { assert, CoursePlatform } from '@microsoft/vscodeedu-api';
import React from 'react';

/** Returns display name for a CoursePlatform value. */
export function getCoursePlatformText(value: CoursePlatform) {
    switch (value) {
        case 'python':
            return 'Python';
        case 'html':
            return 'HTML/CSS/JavaScript';
        default:
            assert.unreachable(value, 'Unexpected course platform value.');
    }
}

/** Course platform display text properties. */
export type CoursePlatformTextProps = Readonly<{
    value: CoursePlatform;
}>;

/** Course platform display text. */
export const CoursePlatformText = (props: CoursePlatformTextProps) => {
    const { value } = props;
    return <>{getCoursePlatformText(value)}</>;
};
